import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

/**
 * Logger for application. In dev mode log to console.log, console.warn and console.err
 * In production mode, log to Logentries
 */
@Injectable()
export class LoggerService {

  /**
   * Logentries access token
   * @type {string}
   */
  private logToken = 'c43cb0b4-989c-4494-988e-83e418847464';
  /**
   * Logentries log url
   * @type {string}
   */
  private logURL: string = 'https://webhook.logentries.com/noformat/logs/' + this.logToken;
  /**
   * Application name for Logentries
   * @type {string}
   */
  private appName: string = 'map-ui';
  /**
   * Use Logentries in production environments
   * @type {boolean}
   */
  private useLogentries = false;

  /**
   * Default constructor
   * @param {HttpClient} http
   */
  constructor(private http: HttpClient) {
  }

  /**
   * Info log stream.
   * @returns {any} - console.log on dev, Logentries stream on production
   */
  get info() {
    if (this.useLogentries) {
      return this.logToEntries;
    } else {
      return console.info.bind(console);
    }
  }

  /**
   * Warn log stream.
   * @returns {any} - console.log on dev, Logentries stream on production
   */
  get warn() {
    if (this.useLogentries) {
      return this.logToEntries;
    } else {
      return console.warn.bind(console);
    }
  }

  /**
   * Error log stream.
   * @returns {any} - console.log on dev, Logentries stream on production
   */
  get error() {
    if (this.useLogentries) {
      return this.logToEntries;
    } else {
      return console.error.bind(console);
    }
  }

  /**
   * Logentries logger method. Usage as with console.log, console.error, etc..
   * @param message
   * @param data
   */
  private logToEntries(message: any, ...data: any[]) {
    let msg: string;
    if (typeof message === 'object') {
      try {
        msg = JSON.stringify(message);
      } catch (err) {
        msg = err;
      }
    } else {
      msg = message;
    }
    for (const row of data) {
      try {
        msg += ', ' + row.toString();
      } catch (err) {
      }
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    this.http.post(this.logURL, 'App: ' + this.appName + ', message: ' + msg, {headers: headers}).subscribe(
      response => {
      },
      error => {
      });
  }
}
